/**
 * Phase 9 — Service worker registration helper.
 *
 * - Only registers in production builds (CRA's NODE_ENV) OR via opt-in env
 *   REACT_APP_ENABLE_SW=true (handy for the e2e/preview pod which serves a
 *   dev build).
 * - On update, posts a custom event so the UI can show a "yeni sürüm hazır"
 *   toast. We don't wire that yet — kept minimal.
 */
export function registerSW() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  const enabled =
    process.env.NODE_ENV === "production" ||
    process.env.REACT_APP_ENABLE_SW === "true";
  if (!enabled) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // eslint-disable-next-line no-console
        console.log("[LUMEN] Service worker registered:", reg.scope);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[LUMEN] SW registration failed:", err);
      });
  });
}

export function unregisterSW() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
}
